import React from "react";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
const ExportToCSV = ({ loading, sortedUsers, packages, buttonStyle = {} }) => {
  const { t } = useTranslation();
  const exportToCSV = () => {
    const dataToExport = sortedUsers.length ? sortedUsers : packages;
    const csvData = dataToExport.map((row) => ({
      Name: row?.userId?.name ?? row?.paymentId?.name ?? "",
      Phone: row?.userId?.phone_no ?? "",
      Email: row?.userId?.email ?? "",
      Vendor: row?.vendorType ?? "",
      "SIM ID": row?.sims?.[0]?.iccid ?? "",
      "Purchase Date": row?.created_at
        ? new Date(row.created_at).toLocaleDateString("en-GB", {
            day: "numeric",
            month: "long",
            year: "numeric",
          })
        : "",
      "Original Price":
        row?.event === "topup"
          ? `${parseFloat(row?.price / 100).toFixed(2)}`
          : `${parseFloat(row?.price).toFixed(2)}`,
      "Discount Price": row?.discountedPrice
        ? `${parseFloat(row?.discountedPrice).toFixed(2)}`
        : `${parseFloat(row?.price).toFixed(2)}`,
    }));

    if (csvData.length === 0) {
      toast.warning(t("No valid user data found to export"), {
        autoClose: 3000,
        closeOnClick: true,
        draggable: true,
        pauseOnHover: true,
      });
      return;
    }

    const csvContent = convertToCSV(csvData);

    downloadCSV(csvContent, "users_data.csv");
  };

  const convertToCSV = (data) => {
    if (!data.length) return "";
    const headers = Object.keys(data[0]);
    const csvRows = [];
    csvRows.push(headers.join(","));
    data.forEach((row) => {
      const values = headers.map((header) => {
        const value = row[header] || "";
        return `"${String(value).replace(/"/g, '""')}"`;
      });
      csvRows.push(values.join(","));
    });

    return csvRows.join("\n");
  };



  const downloadCSV = (csvContent, filename) => {
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");

    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      
      
      link.setAttribute("href", url);
      link.setAttribute("download", filename);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };
  return (
    <div>
      <button
        className="btn btn-primary"
        style={{ marginTop: "65px", ...buttonStyle }}
        onClick={exportToCSV}
        disabled={loading || (!sortedUsers.length && !packages.length)}
      >
        Export to CSV
      </button>
    </div>
  );
};

export default ExportToCSV;
